export default __webpack_public_path__ + "static/media/arrowLeft.84c8295f.svg";